module.exports = __webpack_public_path__ + "img/advertising4.607b706a.png";